/* global axios */
import ApiClient from './ApiClient';

// Secciones de plantillas personalizadas por bandeja (crear/renombrar/reordenar).
class TemplateSectionsAPI extends ApiClient {
  constructor() {
    super('template_sections', { accountScoped: true });
  }

  create(inboxId, name) {
    return axios.post(this.url, { inbox_id: inboxId, name });
  }

  rename(inboxId, id, name) {
    return axios.patch(`${this.url}/${id}`, { inbox_id: inboxId, name });
  }

  reorder(inboxId, orderedIds) {
    return axios.put(`${this.url}/reorder`, {
      inbox_id: inboxId,
      ordered_ids: orderedIds,
    });
  }

  destroy(inboxId, id) {
    return axios.delete(`${this.url}/${id}`, {
      params: { inbox_id: inboxId },
    });
  }
}

export default new TemplateSectionsAPI();
